import React, { Fragment, useState, useRef, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";

import { useAuth } from "../../../context/AuthContext";
import swal from "sweetalert";
import Alert from "sweetalert2";

import { functions } from "../../../firebase";
import { db, storage } from "../../../firebase";
import {
  setDoc,
  getDocs,
  collection,
  updateDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
import {
  ref,
  uploadBytes,
  deleteObject,
  listAll,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import {
  startAddReport,
  startSetReports,
  startRemoveReport,
  startEditReport,
} from "../../../actions/reports";
import { httpsCallable } from "firebase/functions";
import selectReports from "../../../selectors/reports";
import { notifyTopRight, notifyWarning, notifyError } from "../toast/SetToast";
import Toast from "../toast/SetToast";
import PatientReportForm from "./PatientReportForm";
import PatientReportItem from "./PatientReportItem";
import { file } from "jszip";
import {
  SCORED_SLEEP_STUDY_UPLOAD_TYPE,
  UNSCORED_SLEEP_STUDY_UPLOAD_TYPE,
  splitSleepStudyUploads,
  getSleepStudyFileCollection,
  getSleepStudyUploadCollection,
} from "../../../utils/sleepStudyFiles";
import { loadPatientSleepStudyFiles } from "../../../utils/loadSleepStudyFiles";
const PatientSleepStudy = ({
  profile,
  reportsList,
  startAddReport,
  startSetReports,
  startRemoveReport,
}) => {
  const getSignedUrl = httpsCallable(functions, "getSignedUrl");
  const { currentUser } = useAuth();
  const patientHn = String(profile.hn || "").trim();
  const [isEdit, setIsEdit] = useState(false);
  const [reportEditData, setReportEditData] = useState(null);
  const [isLoding, setIsLoading] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [reports, setReports] = useState([]);
  const [sleepstudyList, setSleepStudyList] = useState([]);
  const [fileUrl, setFileUrl] = useState(null);
  const sleepStudyRequestRef = useRef(0);
  const activePatientHnRef = useRef(patientHn);
  const { unscored, scored } = splitSleepStudyUploads(sleepstudyList);

  const onSubmit = async (files, uploadType = UNSCORED_SLEEP_STUDY_UPLOAD_TYPE) => {
    if (!isEdit) {
      const report = {
        hn: patientHn,
        createBy: currentUser.displayName,
        createAt: new Date(),
        scoreUploadType: uploadType,
        ...(uploadType === SCORED_SLEEP_STUDY_UPLOAD_TYPE
          ? { scoreUploadSource: "patient_sleepstudy" }
          : {}),
      };
      const type = "sleepstudy";
      //   startAddReport(report, files, type);
      await SetAddSleepStudy(report, files, type);
    } else {
      setIsEdit(false);
    }
  };

  const onDelete = ({ id, fileCollection }) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        const type = getSleepStudyFileCollection({ fileCollection });
        try {
          await SetRemoveSleepStudy({ hn: patientHn, id, type });
          swal(`Poof! Your file has been deleted!`, { icon: "success" });
        } catch (error) {
          notifyError(error.message || "Unable to delete Sleep Study files");
        }
      } else {
        swal("Canceled");
      }
    });
  };

  const onEdit = (data) => {
    setIsEdit(true);
    setReportEditData(data);
  };

  const onCancelEdit = () => {
    setIsEdit(false);
  };

  const onViewFile = (hn, id, file, type = "sleepstudy") => {
    // console.log(id);
    getSignedUrl({
      folder: `${type}s`,
      hn,
      id,
      filename: file,
    })
      .then((result) => {
        // console.log("url", result.data);
        setFileUrl(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    setCreateModal(true);
  };
  const SetAddSleepStudy = async (reportData = {}, files, type) => {
    const {
      hn = "", createBy = "", createAt = 0,
      scoreUploadType, scoreUploadSource,
    } = reportData;
    const report = { hn, createBy, createAt, scoreUploadType };
    if (scoreUploadSource) report.scoreUploadSource = scoreUploadSource;

    if (!hn) {
      notifyError("HN is required to upload Sleep Study files");
      return;
    }
    if (!files || files.length === 0) return;

    try {
      const fileCollection = getSleepStudyUploadCollection(scoreUploadType);
      const docRef = doc(collection(db, "patients", report.hn, fileCollection));
      await setDoc(docRef, report);
      Alert.fire({
        title: "Uploading files...",
        html: "Please wait while the files are being uploaded.",
        allowOutsideClick: false,
        showConfirmButton: false,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Alert.showLoading();
        },
      });
      const promises = files.map((file) => {
        const storageRef = ref(
          storage,
          `${fileCollection}s/${report.hn}/${docRef.id}/${file.name}`
        );
        const uploadTask = uploadBytesResumable(storageRef, file);
        // swal.showLoading();
        return new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              // Optional: Handle progress updates
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              // console.log("Upload is " + progress + "% done");
              Alert.update({
                html: `Uploading ${file.name} : ${Math.round(progress)}% done`,
              });
            },
            (error) => {
              // Handle unsuccessful uploads
              console.log("error handle upload");
              Alert.close();
              reject(error);
            },
            () => {
              // Handle successful uploads on complete
              console.log("Upload successful");
              Alert.close();
              resolve(uploadTask.snapshot.ref.name);
            }
          );
        });
      });
      // Alert.hideLoading();

      const uploadedFiles = await Promise.all(promises);
      await updateDoc(doc(db, "patients", report.hn, fileCollection, docRef.id), {
        reportFile: uploadedFiles,
      });
      await SetSleepStudy();
      swal(`Uploaded successfully`, {
        icon: "success",
      });
    } catch (error) {
      console.log(error);
      swal(`${error}`, {
        icon: "error",
      });
    }
  };

  const SetRemoveSleepStudy = async ({ hn, id, type }) => {
    if (!hn || !id) throw new Error("Missing Sleep Study file information");
    const docRef = doc(db, "patients", hn, type, id);
    const storageRef = ref(storage, `${type}s/${hn}/${id}`);
    const storedFiles = await listAll(storageRef);
    await Promise.all(storedFiles.items.map((itemRef) => deleteObject(itemRef)));
    await deleteDoc(docRef);
    await SetSleepStudy();
  };

  const SetSleepStudy = useCallback(async () => {
    if (activePatientHnRef.current !== patientHn) return;
    const requestId = ++sleepStudyRequestRef.current;
    const hn = patientHn;
    if (!hn) {
      setSleepStudyList([]);
      return;
    }
    const sleepstudys = await loadPatientSleepStudyFiles(hn);
    if (requestId === sleepStudyRequestRef.current) setSleepStudyList(sleepstudys);
  }, [patientHn]);
  const onDownLoad = (hn,id,file,type = "sleepstudy") => {
    // console.log("hn,id,file ", hn,id,file);
    SetDownLoadSleepStudy(hn, id, type, file);
  };
  const SetDownLoadSleepStudy = async (hn, id, type, fileName) => {
    // console.log(`${type}s/${hn}/${id}/${fileName}`);
    const storageRef = ref(storage, `${type}s/${hn}/${id}/${fileName}`);
    getDownloadURL(storageRef)
      .then((url) => {
        downloadFile(url, fileName);
        // console.log(url)
      })
      .catch((error) => {
        // Handle any errors
        console.error("Error getting file download URL", error);
      });
  };
  const downloadFile = (url, fileName) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "download";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  useEffect(() => {
    let cancelled = false;
    activePatientHnRef.current = patientHn;
    setIsLoading(true);
    setSleepStudyList([]);
    SetSleepStudy()
      .catch((error) => {
        if (!cancelled) notifyError(error.message || "Unable to load Sleep Study files");
      })
      .finally(() => { if (!cancelled) setIsLoading(false); });
    return () => {
      cancelled = true;
      activePatientHnRef.current = null;
      sleepStudyRequestRef.current += 1;
    };
  }, [patientHn, SetSleepStudy]);

  const renderSleepStudySection = (title, rows, uploadType) => (
    <section data-sleep-study-type={uploadType} className="mb-3">
      <PatientReportForm
        hn={patientHn}
        onSubmit={(files) => onSubmit(files, uploadType)}
        text={title}
      />
      {!isLoding && (rows.length ? (
        <PatientReportItem
          reports={rows}
          hn={patientHn}
          onEdit={onEdit}
          onDelete={onDelete}
          onViewFile={onViewFile}
          isDownLoad={true}
          onDownLoad={onDownLoad}
        />
      ) : <div className="col-xl-9 col-lg-12 text-muted mb-3">No {title} files</div>)}
    </section>
  );

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={createModal}
        onHide={() => setCreateModal(false)}
        size="xl"
      >
        <Modal.Header>
          <Modal.Title>Report</Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-0 p-0">
          <div
            className="card-body mx-0 p-0 col-lg-12"
            style={{ height: "85vh" }}
          >
            <iframe
              className="col-lg-12 m-0 p-0"
              src={fileUrl + "#toolbar=0"}
              width="100%"
              height="100%"
            ></iframe>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <div className="col-xl-9 col-lg-12 mb-3 text-muted">
        Compress each sleep study folder into a .zip file, then upload it to the matching section.
      </div>
      {renderSleepStudySection("Unscored Sleep Study", unscored, UNSCORED_SLEEP_STUDY_UPLOAD_TYPE)}
      {renderSleepStudySection("Scored Sleep Study", scored, SCORED_SLEEP_STUDY_UPLOAD_TYPE)}
      {/* {!isEdit ? (
        <PatientReportForm
          onSubmit={onSubmit}
          hn={profile.hn}
          createBy={currentUser.displayName}
        />
      ) : (
        <PatientReportEditForm
          onSubmit={onSubmit}
          onCancel={onCancelEdit}
          hn={profile.hn}
          createBy={currentUser.displayName}
          note={noteEditData}
        />
      )} */}
    </Fragment>
  );
};

export default PatientSleepStudy;
// const mapStateToProps = (state, props) => ({
//   reportsList: selectReports(state.reports),
// });

// const mapDispatchToProps = (dispatch) => ({
//   startSetReports: (reports, type) => dispatch(startSetReports(reports, type)),
//   startEditReport: (id, report, files, type) =>
//     dispatch(startEditReport(id, report, files, type)),
//   startRemoveReport: (data, type) => dispatch(startRemoveReport(data, type)),
//   startAddReport: (report, files, type) =>
//     dispatch(startAddReport(report, files, type)),
// });

// export default connect(undefined, mapDispatchToProps)(PatientSleepStudy);
